import ctl from '@netlify/classnames-template-literals'

export function SafeZoneGuide() {
	const safeZoneClassName = ctl(`
        flex items-center justify-center absolute 
        ring ring-red-500 border border-white
        font-bold
        text-shadow-lg 
        text-white
        `)

	return (
		<div
			data-render-exclude={true}
			className="z-100 text-white absolute inset-0 pointer-events-none transition-opacity duration-300 opacity-[var(--safe-zone-opacity)]"
		>
			<div className={ctl(`${safeZoneClassName} left-0 inset-y-0 w-[5%] bg-red-500/50`)}></div>
			<div className={ctl(`${safeZoneClassName} bottom-0 left-[5%] right-0 h-[14%] bg-red-500/50`)}>
				Avoid area
			</div>
			<div
				className={ctl(
					`${safeZoneClassName} [writing-mode:vertical-lr] bottom-[14%] top-[40%] right-0 w-[14%] bg-red-500/50`,
				)}
			>
				Reels specific
			</div>

			<div className={ctl(`${safeZoneClassName} left-[12%] top-[5%] w-[78%] h-[24%]  bg-amber-500/50`)}>
				Text hook if available
			</div>

			<div className={ctl(`${safeZoneClassName} left-[12%] top-[34%] h-[10%] w-[76%] bg-amber-500/50`)}>
				Main subject / eyes
			</div>

			<div className={ctl(`${safeZoneClassName} left-[12%] top-[58%] h-[14%] w-[76%] bg-amber-500/50`)}>
				Captions
			</div>

			<div className={ctl(`${safeZoneClassName} left-[17%] top-[70%] h-[17%] w-[62%] bg-orange-500/50`)}>
				Learn more
			</div>

			<div className={ctl(`${safeZoneClassName} top-0 inset-x-0 h-[10%] bg-red-500/30`)}>
				Story safe zone
			</div>
		</div>
	)
}
